export default "__VITE_ASSET__BgxbBWuX__"